import React, { useState } from 'react';
import 'react-quill/dist/quill.snow.css';
import './Invoicesetting.css';
import Header from '../../components/Header'
import ReactQuill from 'react-quill';

const NavigationBar = () => {
  return (
    <div className="navigation-buttons">
      <button style={{ backgroundColor: '#03396c', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '4px', margin: '5px', textDecoration: 'none', cursor: 'pointer' }}>
        <a href='/Genera' style={{ textDecoration: 'none', color: 'white' }}>General Settings</a>
      </button>
      <button style={{ backgroundColor:'#03396c', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '4px', margin: '5px', textDecoration: 'none', cursor: 'pointer' }}>
        <a href='/Roaste' style={{ textDecoration: 'none', color: 'white' }}>Roaster</a>
      </button>
      <button style={{ backgroundColor:'#03396c', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '4px', margin: '5px', textDecoration: 'none', cursor: 'pointer' }}>
        <a href='Invoicesettin' style={{ textDecoration: 'none', color: 'white' }}>Invoice Setting</a>
      </button>
      <button style={{ backgroundColor: '#03396c', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '4px', margin: '5px', textDecoration: 'none', cursor: 'pointer' }}>
        <a href='/Feedbac' style={{ textDecoration: 'none', color: 'white' }}>Feedback Question</a>
      </button>
      <button style={{ backgroundColor: '#03396c', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '4px', margin: '5px', textDecoration: 'none', cursor: 'pointer' }}>
        <a href='/Blog' style={{ textDecoration: 'none', color: 'white' }}>Blogs</a>
      </button>
      <button style={{ backgroundColor: '#03396c', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '4px', margin: '5px', textDecoration: 'none', cursor: 'pointer' }}>
        <a href='/Activit' style={{ textDecoration: 'none', color: 'white' }}>Activity Log</a>
      </button>
      <button style={{ backgroundColor: '#03396c', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '4px', margin: '5px', textDecoration: 'none', cursor: 'pointer' }}>
        <a href='/Ap' style={{ textDecoration: 'none', color: 'white' }}>Api Doc</a>
      </button>
     
      <button style={{ backgroundColor:'#03396c', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '4px', margin: '5px', textDecoration: 'none', cursor: 'pointer' }}>
        <a href='/Paymen' style={{ textDecoration: 'none', color: 'white' }}>Tms usage&Payment</a>
      </button>
      <button style={{ backgroundColor: '#03396c', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '4px', margin: '5px', textDecoration: 'none', cursor: 'pointer' }}>
        <a href='/Maintanc' style={{ textDecoration: 'none', color: 'white' }}>Maintance</a>
      </button>
    </div>
  );
};

const InvoiceForm = () => {
  const [invoiceNo, setInvoiceNo] = useState('');
  const [editorContent, setEditorContent] = useState('');

  const handleInvoiceNoChange = (e) => {
    setInvoiceNo(e.target.value);
  };

  const handleEditorChange = (content) => {
    setEditorContent(content);
  };

  const handleSave = () => {
    // Handle save logic here
    console.log('Invoice number:', invoiceNo);
    console.log('Editor content:', editorContent);
    // Reset the form
    setInvoiceNo('');
    setEditorContent('');
  };

  return (
    <div className="container" style={{ border: '1px solid #ccc', borderRadius: '12px' }}>
      <h4>Invoice Basic Settings</h4>
      <div className="form-container">
        <form>
          <div className="form-group">
            <label htmlFor="invoiceNo">Invoice Basic Prefix:</label>
            <input
              type="text"
              id="invoiceNo"
              className="form-control"
              placeholder=""
            
            />
          </div>
          <div className="form-group">
            <label htmlFor="invoiceNo">Invoice Starting No:</label>
            <input
              type="text"
              id="invoiceNo"
              className="form-control"
              placeholder=""
           
            />
          </div>
          <div className="form-group">
            <label htmlFor="invoiceNo">Payment Terms</label>
            <input
              type="text"
              id="invoiceNo"
              className="form-control"
              placeholder="Cash Cheque"
            
            />
          </div>
        
          
        </form>
      </div>
      <div className="instructions-container">
        {/* Content goes here */}
        <h6>--Instruction(Shown at bottom of the Page)</h6>
        <ReactQuill
          value={editorContent}
          onChange={handleEditorChange}
          placeholder="Enter your text"
        />
        
      </div>
      <button type="button" className="btn btn-primary" onClick={handleSave} style={{background:'#03396c'}}>
            Save
          </button>
    </div>
  );
};

const App = () => {
  const [name, setName] = useState('');
  const [calculation, setCalculation] = useState('');

  const handleNameChange = (e) => {
    setName(e.target.value);
  };

  const handleCalculationChange = (e) => {
    setCalculation(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Perform submit logic here
    console.log('Name:', name);
    console.log('Calculation:', calculation);
  };

  const [inputValue, setInputValue] = useState('');

  const handleChange = (event) => {
    setInputValue(event.target.value);
  };

  const handleSave = () => {
    // Handle save logic here
    console.log('Invoice number:', );
    // Reset the form
  };

  return (
    <div className="container" style={{ border: '1px solid #ccc', borderRadius: '12px' }}>
      <h4>Add New Particular</h4>
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">Name:</label>
          <input
            type="text"
            name="myInput"
            placeholder="Enter your name"
         
          />
        </div>
        <div className="form-group">
          <label htmlFor="name">Calculation:</label>
          <input
            type="text"
            name="myInput"
            placeholder="Enter your calculation"
         
          />
        </div>
       
      </form>
      <button type="button" className="btn btn-primary" onClick={handleSave} style={{background:'#03396c'}}>
            Save
          </button>
    </div>
  );
};const tableData = [
    { id: 1, name: 'Item 1', type: 'Type A', mode: 'Manual', value: 10, isEditing: false },
    { id: 2, name: 'Item 2', type: 'Type B', mode: 'Automatic', value: 20, isEditing: false },
    { id: 3, name: 'Item 3', type: 'Type A', mode: 'Manual', value: 15, isEditing: false },
    { id: 4, name: 'Item 4', type: 'Type C', mode: 'Automatic', value: 25, isEditing: false },
    { id: 5, name: 'Item 5', type: 'Type B', mode: 'Manual', value: 18, isEditing: false },
  ];
  
  const ResponsiveTable = () => {
    const [editableItemId, setEditableItemId] = useState(null);
    const [editedData, setEditedData] = useState({});
  
    const handleEdit = (itemId, column) => {
      setEditableItemId(itemId);
      const item = tableData.find((item) => item.id === itemId);
      setEditedData({ ...item, column });
    };
  
    const handleSave = () => {
      // Perform save operation with the updated data
      const itemIndex = tableData.findIndex((item) => item.id === editableItemId);
      if (itemIndex !== -1) {
        tableData[itemIndex] = { ...editedData };
      }
  
      setEditableItemId(null);
      setEditedData({});
    };
  
    const handleDelete = (itemId) => {
      console.log(`Delete item with ID ${itemId}`);
    };
  
    return (
      <div className="table-container" style={{ border: '1px solid #ccc', borderRadius: '12px' }}>
        <table className="table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Type</th>
              <th>Calculation Mode</th>
              <th>Value</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((item) => (
              <tr key={item.id}>
                <td>
                  {editableItemId === item.id ? (
                    <input
                      type="text"
                      value={editedData.name || item.name}
                      onChange={(e) =>
                        setEditedData({ ...editedData, name: e.target.value })
                      }
                    />
                  ) : (
                    item.name
                  )}
                </td>
                <td>
                  {editableItemId === item.id ? (
                    <input
                      type="text"
                      value={editedData.type || item.type}
                      onChange={(e) =>
                        setEditedData({ ...editedData, type: e.target.value })
                      }
                    />
                  ) : (
                    item.type
                  )}
                </td>
                <td>
                  {editableItemId === item.id ? (
                    <input
                      type="text"
                      value={editedData.mode || item.mode}
                      onChange={(e) =>
                        setEditedData({ ...editedData, mode: e.target.value })
                      }
                    />
                  ) : (
                    item.mode
                  )}
                </td>
                <td>
                  {editableItemId === item.id ? (
                    <input
                      type="text"
                      value={editedData.value || item.value}
                      onChange={(e) =>
                        setEditedData({ ...editedData, value: e.target.value })
                      }
                    />
                  ) : (
                    item.value
                  )}
                </td>
                <td>
                  {editableItemId === item.id ? (
                    <div className="btn-group" role="group">
                      <button
                        type="button"
                        className="btn btn-success btn-sm"
                        onClick={handleSave}
                      >
                        Save
                      </button>
                    </div>
                  ) : (
                    <div className="btn-group" role="group" >
  <button
    type="button"
    className="btn btn-primary btn-sm"
    onClick={() => handleEdit(item.id, null)}
    style={{ padding: '1px 30px' }}>
    Edit
  </button>
</div>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };


  
const EmailPreview = () => {
  return (
    <div className="container">
      <h1>Email Preview</h1>
      <div className="table-responsive">
        <table className="table table-bordered">
          <thead>
            <tr>
              <th>Column 1</th>
              <th>Column 2</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Row 1, Cell 1</td>
              <td>Row 1, Cell 2</td>
            </tr>
            <tr>
              <td>Row 2, Cell 1</td>
              <td>Row 2, Cell 2</td>
            </tr>
            <tr>
              <td>Row 3, Cell 1</td>
              <td>Row 3, Cell 2</td>
            </tr>
            <tr>
              <td>Row 4, Cell 1</td>
              <td>Row 4, Cell 2</td>
            </tr>
            <tr>
              <td>Row 5, Cell 1</td>
              <td>Row 5, Cell 2</td>
            </tr>
          </tbody>
        </table>
      </div>
      <button className="btn btn-primary">Login</button>
    </div>
  );
};
const Invoicesetting = () => {
    return (
      <div>
      <Header/>
        <NavigationBar />
     
       
        <div className="container">
        <div className="row">
          <div className="col-md-6">
          <InvoiceForm />
          </div>
          <div className="col-md-6">
          <App/>
          </div>
          <div className="col-md-6">
      
          </div>
        </div>
      </div>

      <ResponsiveTable/>
      </div>
    );
  };
  
  export default Invoicesetting;